export default "__VITE_ASSET__BeYmZ$6c__"